var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "left-side-menu" }, [
    _c("div", { staticClass: "sidebar-content" }, [
      _c("div", { attrs: { id: "sidebar-menu" } }, [
        _c(
          "ul",
          { staticClass: "metismenu", attrs: { id: "side-menu" } },
          _vm._l(_vm.renderMenuItems, function (menuItem, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "side-nav-title side-nav-item",
                class: {
                  "mm-active": _vm.currentRoute.match(menuItem.pathActive),
                },
              },
              [
                !menuItem.items && menuItem.route
                  ? _c(
                      "router-link",
                      {
                        staticClass: "side-nav-link side-nav-link-ref",
                        attrs: {
                          to: { name: menuItem.route },
                          "exact-active-class": ".side-nav-item",
                        },
                      },
                      [
                        _c("feather", { attrs: { type: menuItem.icon } }),
                        _c("span", [_vm._v(_vm._s(menuItem.label))]),
                      ],
                      1
                    )
                  : _vm._e(),
                !menuItem.items && menuItem.routeOut
                  ? _c(
                      "a",
                      {
                        staticClass: "side-nav-link",
                        attrs: { href: menuItem.routeOut, target: "_blank" },
                      },
                      [
                        _c("feather", { attrs: { type: menuItem.icon } }),
                        _c("span", [_vm._v(_vm._s(menuItem.label))]),
                      ],
                      1
                    )
                  : _vm._e(),
                menuItem.items
                  ? _c(
                      "router-link",
                      {
                        staticClass: "side-nav-link",
                        attrs: {
                          to: { name: menuItem.route },
                          "aria-expanded":
                            _vm.currentRoute.match(menuItem.pathActive) !==
                            null,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.clickParentItem(menuItem)
                          },
                        },
                      },
                      [
                        _c("feather", { attrs: { type: menuItem.icon } }),
                        _c("span", [_vm._v(_vm._s(menuItem.label))]),
                        _c("span", { staticClass: "menu-arrow" }),
                      ],
                      1
                    )
                  : _vm._e(),
                menuItem.items
                  ? _c(
                      "ul",
                      {
                        staticClass: "nav-second-level mm-collapse",
                        class: {
                          "mm-show": _vm.currentRoute.match(
                            menuItem.pathActive
                          ),
                        },
                      },
                      _vm._l(menuItem.items, function (item, index1) {
                        return _c(
                          "li",
                          { key: index1 },
                          [
                            _c(
                              "router-link",
                              { attrs: { to: { name: item.route } } },
                              [_vm._v(_vm._s(item.label))]
                            ),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ],
              1
            )
          }),
          0
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }